export default __webpack_public_path__ + "static/1-3--fc6e310bc0343ef8714f7ccc22936ad9.png";